import { gql } from "@/__generated__/gql";

export const EVENT_DETAILS_PARTICIPANT_COUNTS = gql(`
query liveEventParticipantCounts($eventId: ID!, $filters:StudentListFilterInput) {
    node(id: $eventId) {
      id
      ... on LiveEvent {
        participantsByFunnelState(filters:$filters) {
          state
          value
        }
      }
    }
  }
`);
